@let companionChatActive = companionChatActive$ | async;

<div class="container-fluid flex-container" nimbusTheme [target]="applicationElement" [class.companion-split-screen]="companionChatActive">
  @if (translationsReady$ | async) {
    @if (showMenu$ | async) {
      <nimbus-menu></nimbus-menu>
    }
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  } @else {
    <nimbus-spinner [small]="false" [height]="120"></nimbus-spinner>
  }
  @defer (when companionChatActive) {
    <nimbus-companion-split-screen-resizer></nimbus-companion-split-screen-resizer>
    <nimbus-companion-chat-panel class="companion-split-screen-panel" [splitScreen]="true"></nimbus-companion-chat-panel>
  }
</div>
